import Modal from "../../../../../components/portal/Modal";
import { X, Check } from "lucide-react";
import { formatDate } from "../../../../../functions/dateTime/formatDate";
import useImageUrl from "../../../../../CustomHooks/useImageUrl";

const CylinderHistoryDialog = ({ dialogDetails, close, handleImageView }) => {
  const { data, state } = dialogDetails;
  const picture = data.pictureList ? data.pictureList[0] : null;
  const { getImageUrl } = useImageUrl();

  return (
    <Modal onClose={close} modalWidth="view-dialog-content">
      <div className="flex justify-between pb-2">
        <h3 className="text-dark-blue font-medium text-xl">Cylinder {state}</h3>
        <p className="text-gray-500 font-medium">
          {state === "Dispatched"
            ? formatDate(data.createdAt)
            : formatDate(data.updatedAt)}
        </p>
      </div>
      <div className="cy-history-conditions-dialog">
        <h4 className="cy-history-dialogH4">Cylinder Conditions</h4>
        <div className="bg-white rounded-md p-2 pb-1">
          {cylinderChecks.map(({ label, key }, index) => (
            <div key={key} className="row-b-line">
              <p>{label}</p>
              {data[key] ? <Check color="green" /> : <X color="red" />}
            </div>
          ))}
        </div>
        <div className="border-t-1 p-2 mt-1">
          {picture ? (
            <>
              {" "}
              <h4 className="cy-history-dialogH4 pt-3">Cylinder Photo</h4>
              <img
                src={getImageUrl(picture)}
                alt="cylinder"
                className="border p-1 rounded-md shadow-100 max-md:w-20 bg-white cursor-pointer"
                width={100}
                height={100}
                onClick={() => handleImageView(getImageUrl(picture))}
              />
            </>
          ) : (
            <p className="text-gray-500 text-sm">No Photo</p>
          )}
        </div>
        <h4 className="cy-history-dialogH4 pt-3">Vehicle Details</h4>
        <div className="bg-white rounded-md p-2">
          {vehicleDetails.map(({ label, key }, index) => (
            <div key={key} className="row-b-line">
              <p>{label}</p>
              <p>{data.vehicle[key]}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default CylinderHistoryDialog;

const cylinderChecks = [
  { label: "Gas In Cylinder", key: "gasInCylinder" },
  { label: "Water In Cylinder", key: "waterInCylinder" },
  { label: "Cap On Cylinder", key: "capOnCylinder" },
  { label: "Valve Damaged", key: "valveDamaged" },
  { label: "Paint Condition", key: "paintCondition" },
];

const vehicleDetails = [
  { label: "Number", key: "vehicleNumber" },
  { label: "Driver Name", key: "driverName" },
  { label: "Driver Phone", key: "driverMobile" },
  { label: "Modal", key: "vehicleModel" },
  { label: "Reading", key: "vehicleReading" },
];
